module.exports = __webpack_public_path__ + "static/02-8c2442d7df0746bcb20bb46988491ed9.jpg";